module.exports = __webpack_public_path__ + "img/bj27.f104434e.png";